import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustStrip from './components/TrustStrip';
import ShopByCategory from './components/ShopByCategory';
import FeaturedCollections from './components/FeaturedCollections';
import WhyEclectic from './components/WhyEclectic';
import ProductGrid from './components/ProductGrid';
import ReviewsSection from './components/ReviewsSection';
import OurStory from './components/OurStory';
import CtaBanner from './components/CtaBanner';
import AIAnswerBlocks from './components/AIAnswerBlocks';
import FaqSection from './components/FaqSection';
import PhotoGallery from './components/PhotoGallery';
import ShowroomSection from './components/ShowroomSection';
import InquiryForm from './components/InquiryForm';

export default function Home() {
  return (
    <div className="min-w-[1024px]">
      <Navbar />
      <main>
        {/* 1. Hero */}
        <HeroSection />
        {/* 2. Trust strip */}
        <TrustStrip />
        {/* 3. Shop by Category — rich visual cards */}
        <ShopByCategory />
        {/* 4. Featured Collections — asymmetric grid */}
        <FeaturedCollections />
        {/* 5. Why Choose Us — dark section */}
        <WhyEclectic />
        {/* 6. Featured Products */}
        <ProductGrid />
        {/* 7. Customer Reviews */}
        <ReviewsSection />
        {/* 8. Our Story */}
        <OurStory />
        {/* 9. Mid-page CTA */}
        <CtaBanner />
        {/* 10. AI Answer blocks for SEO */}
        <AIAnswerBlocks />
        {/* 11. FAQ */}
        <FaqSection />
        {/* 12. Photo Gallery */}
        <PhotoGallery />
        {/* 13. Showroom + Local SEO + Map */}
        <ShowroomSection />
        {/* 14. Lead form */}
        <InquiryForm />
      </main>
      <Footer />
    </div>
  );
}
